module.exports = __webpack_public_path__ + "static/media/jeff_cartoon.c5fc3507.png";